"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataEnrichmentPrefs = exports.setShowSimilarTitles = exports.getShowSimilarTitles = exports.setShowMaturityRating = exports.getShowMaturityRating = exports.setShowTmdbDescription = exports.getShowTmdbDescription = exports.setShowPosterRatings = exports.getShowPosterRatings = exports.setShowTmdbCast = exports.getShowTmdbCast = void 0;
var react_1 = require("react");
var STORAGE_KEY_SHOW_TMDB_CAST = 'stremio_show_tmdb_cast';
var STORAGE_KEY_SHOW_POSTER_RATINGS = 'stremio_show_poster_ratings';
var STORAGE_KEY_SHOW_TMDB_DESCRIPTION = 'stremio_show_tmdb_description';
var STORAGE_KEY_SHOW_MATURITY_RATING = 'stremio_show_maturity_rating';
var STORAGE_KEY_SHOW_SIMILAR_TITLES = 'stremio_show_similar_titles';
var EVENT_NAME = 'stremio-data-enrichment-prefs-changed';
var parseBool = function (value, defaultValue) {
    if (value === null)
        return defaultValue;
    return value === 'true';
};
var getShowTmdbCast = function () {
    try {
        return parseBool(window.localStorage.getItem(STORAGE_KEY_SHOW_TMDB_CAST), true);
    }
    catch (_a) {
        return true;
    }
};
exports.getShowTmdbCast = getShowTmdbCast;
var setShowTmdbCast = function (value) {
    try {
        window.localStorage.setItem(STORAGE_KEY_SHOW_TMDB_CAST, value ? 'true' : 'false');
    }
    catch (_a) {
        // ignore
    }
    window.dispatchEvent(new Event(EVENT_NAME));
};
exports.setShowTmdbCast = setShowTmdbCast;
var getShowPosterRatings = function () {
    try {
        return parseBool(window.localStorage.getItem(STORAGE_KEY_SHOW_POSTER_RATINGS), true);
    }
    catch (_a) {
        return true;
    }
};
exports.getShowPosterRatings = getShowPosterRatings;
var setShowPosterRatings = function (value) {
    try {
        window.localStorage.setItem(STORAGE_KEY_SHOW_POSTER_RATINGS, value ? 'true' : 'false');
    }
    catch (_a) {
        // ignore
    }
    window.dispatchEvent(new Event(EVENT_NAME));
};
exports.setShowPosterRatings = setShowPosterRatings;
var getShowTmdbDescription = function () {
    try {
        return parseBool(window.localStorage.getItem(STORAGE_KEY_SHOW_TMDB_DESCRIPTION), false);
    }
    catch (_a) {
        return false;
    }
};
exports.getShowTmdbDescription = getShowTmdbDescription;
var setShowTmdbDescription = function (value) {
    try {
        window.localStorage.setItem(STORAGE_KEY_SHOW_TMDB_DESCRIPTION, value ? 'true' : 'false');
    }
    catch (_a) {
        // ignore
    }
    window.dispatchEvent(new Event(EVENT_NAME));
};
exports.setShowTmdbDescription = setShowTmdbDescription;
var getShowMaturityRating = function () {
    try {
        return parseBool(window.localStorage.getItem(STORAGE_KEY_SHOW_MATURITY_RATING), false);
    }
    catch (_a) {
        return false;
    }
};
exports.getShowMaturityRating = getShowMaturityRating;
var setShowMaturityRating = function (value) {
    try {
        window.localStorage.setItem(STORAGE_KEY_SHOW_MATURITY_RATING, value ? 'true' : 'false');
    }
    catch (_a) {
        // ignore
    }
    window.dispatchEvent(new Event(EVENT_NAME));
};
exports.setShowMaturityRating = setShowMaturityRating;
var getShowSimilarTitles = function () {
    try {
        return parseBool(window.localStorage.getItem(STORAGE_KEY_SHOW_SIMILAR_TITLES), true);
    }
    catch (_a) {
        return true;
    }
};
exports.getShowSimilarTitles = getShowSimilarTitles;
var setShowSimilarTitles = function (value) {
    try {
        window.localStorage.setItem(STORAGE_KEY_SHOW_SIMILAR_TITLES, value ? 'true' : 'false');
    }
    catch (_a) {
        // ignore
    }
    window.dispatchEvent(new Event(EVENT_NAME));
};
exports.setShowSimilarTitles = setShowSimilarTitles;
var useDataEnrichmentPrefs = function () {
    var _a = (0, react_1.useState)(0), version = _a[0], setVersion = _a[1];
    (0, react_1.useEffect)(function () {
        var onChange = function () { return setVersion(function (v) { return v + 1; }); };
        window.addEventListener('storage', onChange);
        window.addEventListener(EVENT_NAME, onChange);
        return function () {
            window.removeEventListener('storage', onChange);
            window.removeEventListener(EVENT_NAME, onChange);
        };
    }, []);
    var showTmdbCast = (0, react_1.useMemo)(function () { return (0, exports.getShowTmdbCast)(); }, [version]);
    var showPosterRatings = (0, react_1.useMemo)(function () { return (0, exports.getShowPosterRatings)(); }, [version]);
    var showTmdbDescription = (0, react_1.useMemo)(function () { return (0, exports.getShowTmdbDescription)(); }, [version]);
    var showMaturityRating = (0, react_1.useMemo)(function () { return (0, exports.getShowMaturityRating)(); }, [version]);
    var showSimilarTitles = (0, react_1.useMemo)(function () { return (0, exports.getShowSimilarTitles)(); }, [version]);
    var updateShowTmdbCast = (0, react_1.useCallback)(function (value) { return (0, exports.setShowTmdbCast)(value); }, []);
    var updateShowPosterRatings = (0, react_1.useCallback)(function (value) { return (0, exports.setShowPosterRatings)(value); }, []);
    var updateShowTmdbDescription = (0, react_1.useCallback)(function (value) { return (0, exports.setShowTmdbDescription)(value); }, []);
    var updateShowMaturityRating = (0, react_1.useCallback)(function (value) { return (0, exports.setShowMaturityRating)(value); }, []);
    var updateShowSimilarTitles = (0, react_1.useCallback)(function (value) { return (0, exports.setShowSimilarTitles)(value); }, []);
    return {
        showTmdbCast: showTmdbCast,
        showPosterRatings: showPosterRatings,
        showTmdbDescription: showTmdbDescription,
        showMaturityRating: showMaturityRating,
        showSimilarTitles: showSimilarTitles,
        setShowTmdbCast: updateShowTmdbCast,
        setShowPosterRatings: updateShowPosterRatings,
        setShowTmdbDescription: updateShowTmdbDescription,
        setShowMaturityRating: updateShowMaturityRating,
        setShowSimilarTitles: updateShowSimilarTitles,
    };
};
exports.useDataEnrichmentPrefs = useDataEnrichmentPrefs;
